// extracted by mini-css-extract-plugin
module.exports = {"root":"OrdersList_root__1fwIh"};